import { useCallback } from "react";
import { useIntl } from "react-intl";

const useColumnHeader = () => {
  const { formatMessage } = useIntl();

  const formatHeader = useCallback(
    (intlMsg) => {
      return formatMessage(intlMsg).toUpperCase();
    },
    [formatMessage]
  );

  return { formatHeader };
};

export default useColumnHeader;
